export default __webpack_public_path__ + "static/profile-one-mobile-4b048ab3cdd696195de3dac49d2794f5.jpg";